<template>
  <div class="container-flight margin_container_hf">
    <PDKModal
      :buttonObject="modalButtonProps"
      v-if="showTimerModal"
      @btnAction="goToSearch"
    >
      <div style="text-align: center" slot="body">
        <img
          id="timer-logo"
          width="150"
          height="150"
          src="../../../public/img/out-of-ti.png"
        />
        <h4 style="margin-top: 10px">زمان شما برای تایید رزرو به اتمام رسید</h4>
      </div>
    </PDKModal>
    <PDKSpinner v-if="showCreditSpinner" />
    <div v-else>
      <ChangeSearch :searchItems="searchItems" />
      <div>
        <h3>
          <i class="icon-info-1"></i>اطلاعات هتل + پرواز
        </h3>
      </div>
      <div class="row">
        <div class="col-md-7">
          
          <PdkSelectedFlight
            :selectedFlight="bookingDetail.package.flight"
            :isTwoway="true"
          ></PdkSelectedFlight>
        </div>
        <div class="col-md-5">
          <PdkSelectedRoom
            :hotelDetail="bookingDetail.package.hotelDetail"
            :selectedRoom="bookingDetail.package.hotel"
          />
        </div>
      </div>

      <div>
        <h3>
          <i class="icon-users-1"></i>اطلاعات مسافرین
        </h3>
      </div>
      <div class="cart-section">
        <table class="base-tables">
          <thead>
            <tr  class="rwd-table-header">
              <th></th>
              <th>نام رزرو کننده</th>
              <th>نام رزرو کننده لاتین</th>
              <th>جنسیت</th>
              <th>تاریخ تولد</th>
              <th>ملیت</th>
              <th>کدملی / شماره پاسپورت</th>
              <th>
                <a class="" @click="goBack()">ویرایش</a>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(passenger, index) in bookingDetail.passengers"
              :key="index"
            >
              <td data-th="سن" v-if="passenger.ageType === 'ADL'">
                <i style="color: #acacac" class="icon-adult addon-tb"></i>
                بزرگسال
              </td>
              <td data-th="سن" v-if="passenger.ageType === 'CHL'">
                <i style="color: #acacac" class="icon-child addon-tb"></i>
                کودک
              </td>
              <td data-th="سن" v-if="passenger.ageType === 'INF'">
                <i style="color: #acacac" class="icon-guest addon-tb"></i>
                نوزاد
              </td>
              <td class="addon-tb" data-th="نام رزرو کننده">
                <strong
                  >{{ passenger.persianName }}&nbsp;{{
                    passenger.persianFamily
                  }}</strong
                >
              </td>
              <td class="addon-tb" data-th=" نام رزرو کننده لاتین">
                <strong
                  >{{ passenger.englishName }}&nbsp;{{
                    passenger.englishFamily
                  }}</strong
                >
              </td>
              <td class="addon-tb" data-th=" جنسیت" v-if="passenger.genderId === 1">مرد</td>
              <td class="addon-tb" data-th=" جنسیت" v-else>زن</td>
              <td class="addon-tb" data-th=" تاریخ تولد">
                <strong>{{ passenger.birthDate }}</strong>
              </td>
              <td data-th=" ملیت" class="options addon-tb">
                <strong v-if="passenger.nationalityId === 1">ایرانی</strong>
                <strong v-else>غیر ایرانی</strong>
              </td>
              <td data-th=" کدملی / پاسپورت" class="options addon-tb">
                <strong>{{ passenger.nationalCode }}</strong>
              </td>
              <td data-th=""></td>
            </tr>
          </tbody>
        </table>
        <div class="customer_request">
          <strong style="color: #08446a; margin-left: 5px"
            >درخواست مسافر:</strong
          >
          <span>{{ bookingDetail.guestRequest }}</span>
        </div>

        <div>
          <h3>
            <i class="icon-money-1"></i>جزئیات قیمت
          </h3>
        </div>
        <div class="row cart-section">
          <table class="col-md-7 rwd-table">
            <thead>
              <tr class="rwd-table-header">
                <th>اتاق</th>
                <th>به ازای هر شب</th>
                <th>تخت اضافه</th>
                <th>تخت اضافه کودک</th>
                <!-- <th>
								جمع 
							</th> -->
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in roomsPriceDetail" :key="index">
                <td data-th="اتاق">
                  <strong>{{ item.roomName }}</strong>
                </td>
                <td data-th="به ازای هر شب">
                  <div class="td_container">
                    <strong id="rack_price">{{
                      item.rackPrice | numFormat
                    }}</strong>
                    <strong id="normal_price">{{
                      item.price | numFormat
                    }}</strong>
                  </div>
                </td>

                <td data-th="تخت اضافه" v-if="item.extraBedPrice > 0">
                  <div class="td_container">
                    <strong id="rack_price">{{
                      item.rackExtraBedPrice | numFormat
                    }}</strong>
                    <strong id="normal_price">{{
                      item.roomExtraBedPrice | numFormat
                    }}</strong>
                  </div>
                </td>
                <td data-th="تخت اضافه" v-else><strong>0</strong></td>

                <td data-th="تخت اضافه کودک" v-if="item.childWithPrice > 0">
                  <div class="td_container">
                    <strong id="rack_price">{{
                      item.rackChildPrice | numFormat
                    }}</strong>
                    <strong id="normal_price">{{
                      item.childPrice | numFormat
                    }}</strong>
                  </div>
                </td>
                <td data-th="تخت اضافه کودک" v-else><strong>0</strong></td>

                <!-- <td>
								<strong>{{item.totalRackPrice  | numFormat }}</strong>
							</td> -->
              </tr>
            </tbody>
          </table>
          <table
            style="margin-right: 10px"
            class="col-md-4 rwd-table"
          >
            <thead>
              <tr  class="rwd-table-header">
                <th></th>
                <th>پرواز رفت</th>
                <th>پرواز برگشت</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td data-th="هزینه پرواز">
                  <strong>هزینه پرواز</strong>
                </td>
                <td  data-th="پرواز رفت">
                  <div class="td_container">
                    <strong id="rack_price">{{
                      departureFlightProviderPrice | numFormat
                    }}</strong>
                    <strong id="normal_price">{{
                      departureFlightPrice | numFormat
                    }}</strong>
                  </div>
                </td>

                <td  data-th="پرواز برگشت" class="td_container">
                  <div class="td_container">
                    <strong id="rack_price">{{
                      returnFlightProviderPrice | numFormat
                    }}</strong>
                    <strong id="normal_price">{{
                      returnFlightPrice | numFormat
                    }}</strong>
                  </div>
                </td>

                <!-- <td>
								<strong>{{item.totalRackPrice  | numFormat }}</strong>
							</td> -->
              </tr>
            </tbody>
          </table>
        </div>

        <div class="cart-options clearfix">
          <div class="float-left">
            <!-- <div class="apply-coupon">
							<div class="form-group">
								<input type="text" name="coupon-code" value="" placeholder="Your Coupon Code" class="form-control">
							</div>
							<div class="form-group">
								<button type="button" class="btn_cart_outine">Apply Coupon</button>
							</div>
						</div> -->
          </div>
        </div>
        <br />
        <div class="row justify-content-end">
          <div
            style="font-size: 16px; margin-top: 40px"
            class="column col-lg-6 col-md-6"
          >
            <div
              style="line-height: 2; margin-bottom: 30px"
              class="totals-table"
            >
              <div class="clearfix">
                <span class="col">جمع مبلغ: </span
                ><span
                  style="text-decoration: line-through; font-weight: bold"
                  class="col"
                  >{{ packageTotalRackPrice | numFormat | rial }}</span
                >
              </div>
              <div class="clearfix total">
                <span class="col">مبلغ قابل پرداخت :</span
                ><span style="font-weight: bold" class="col">{{
                  packageTotalPrice | numFormat | rial
                }}</span>
              </div>
            </div>
            <div class="role-text">
              <input
                :disabled="isDisableRoleCheck"
                v-model="roleChecked"
                type="checkbox"
              />
              &ensp;
              <label
                ><a
                  href="#role-dialog"
                  id="role_link"
                  style="cursor: pointer !important"
                  class="role"
                  ><span style="cursor: pointer !important"
                    >قوانین و مقررات</span
                  >
                </a>
                را می پذیرم.</label
              >
            </div>

            <div class="radios">
              <div class="radio">
                <input
                  type="radio"
                  id="bank"
                  :value="false"
                  v-model="isCredit"
                  
                  checked
                />
                <label for="bank">
                  <div class="checker"></div>
                  <img
                    width="20px"
                    height="20px"
                    style="margin-left: 4px"
                    src="../../../public/img/mellat.png"
                    alt=""
                  />
                  پرداخت آنلاین
                </label>
              </div>

              <div class="radio">
                <input
                  :disabled="isDisableCreditChecked"
                  type="radio"
                  id="credit"
                  :value="true"
                  v-model="isCredit"
                  name="radio"
                />
                <label for="credit">
                  <div class="checker"></div>
                  <span>
                    پرداخت از اعتبار
                    <span style="color: #08446a; font-weight: bold"
                      >( <span>{{ deposit | numFormat }}</span> ریال)</span
                    >
                  </span>
                </label>
              </div>
            </div>

            <div v-if="isDisableTimer">
              <button
                style="width: 100%; width: 75%; margin-right: 14%"
                disabled
                class="btn btn-primary"
              >
                <span v-show="!isLoading"
                  >پرداخت و رزرو <i class="icon-left"></i
                ></span>
                <span v-show="isLoading"
                  >در حال پردازش منتظر بمانید ...
                  <i class="fa fa-spinner fa-pulse"></i
                ></span>
              </button>
            </div>
            <div v-else>
              <button
                style="width: 100%; width: 75%; margin-right: 14%"
                @click="book"
                :disabled="isDisableButton"
                class="btn btn-primary"
              >
                <span v-show="!isLoading"
                  >پرداخت و رزرو <i class="icon-left"></i
                ></span>
                <span v-show="isLoading"
                  >در حال پردازش منتظر بمانید ...
                  <i class="fa fa-spinner fa-pulse"></i
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Role
        :roleType="'hotel-flight'"
        :hotelDetail="bookingDetail.package.hotelDetail"
      />
    </div>
  </div>
</template>


<script>
import PdkSelectedFlight from "@/components/flight/PdkSelectedFlight";
import PdkSelectedRoom from "@/components/tour/SelectedRoom";
import PDKSpinner from "../../components/PDKReserveSpinner";
import Role from "@/components/tour/PDKRoles";

import moment from "moment";
import ChangeSearch from "@/components/tour/ChangeSearch";
import dateUtil from "../../utils/date";
import Summary from "@/components/tour/SummaryInfo";
import Store from "./store/index";
import PDKModal from "@/components/PDKAlertModal";
import jalaaliMoment from "moment-jalaali";

import $ from "jquery";

// import Vue from "vue";

require("linqjs");

export default {
  store: Store,
  provide() {
    return {
      //   forms: Vue.computed(() => this.forms),
    };
  },
  components: {
    Role,
    PdkSelectedRoom,
    PdkSelectedFlight,
    PDKSpinner,
    Summary,
    PDKModal,
    ChangeSearch,
  },
  data() {
    return {
      showCreditSpinner: false,
      totalRoomsPrice: 0,
      totalPackagePrice: 0,
      departureFlightPrice: 0,
      returnFlightPrice: 0,
      totalFlightPrice: 0,
      departureFlightProviderPrice: 0,
      returnFlightProviderPrice: 0,
      totalFlightProviderPrice: 0,

      roomsPriceDetail: [],
      isDisableTimer: false,
      isDisableCreditChecked: false,
      deposit: 0,
      reserveNo: "",
      isCredit: false,
      isDisableButton: false,
      isDisableRoleCheck: false,
      isLoading: false,
      roleChecked: false,
      totalNight: 0,
      passengers: [],
      passengerForm: [],
      modalButtonProps: {
        title: "جستجوی مجدد",
      },
      showTimerModal: false,

      searchItems: {},
      params: {},

      bookingDetail: {},
      recaptchaToken: null,
    };
  },
  watch: {
    roleChecked: function (val) {
      if (val === true) {
        this.isDisableButton = false;
      } else {
        this.isDisableButton = true;
      }
    },
    isLoading: function (val) {
      if (val === true) {
        this.isDisableButton = true;
        this.isDisableRoleCheck = true;
      } else {
        this.isDisableRoleCheck = false;
        this.isDisableButton = false;
      }
    },
  },
  created() {
    this.params = this.$route.query;
    this.getSearchItems();
    this.bookingDetail = this.$store.getters["Book/GetBookingDetails"];
console.log('this.bookingDetail',this.bookingDetail)
    if (!Object.keys(this.bookingDetail).length) {
      this.goToSearch();
    }
   
    this.getCredit();
    if (this.roleChecked === false) {
      this.isDisableButton = true;
    }
    var x = setTimeout(() => {
      this.isDisableTimer = true;
      this.endTimeCountdown();
    }, 600000);
    this.totalRoomPriceDetail();
    this.flightPriceDetail(this.bookingDetail.package.flight);
  },
  computed: {
    flightTotalPrice() {
      return this.calcFlightTotalPrice(this.bookingDetail.package.flight);
    },
    roomTotalPrice() {
      return this.calcRoomTotalPrice(this.bookingDetail.package.hotel);
    },
    roomTotalRackPrice() {
      return this.calcRoomTotalRackPrice(this.bookingDetail.package.hotel);
    },
    packageTotalPrice() {
      var roomPrice = this.calcRoomTotalPrice(this.bookingDetail.package.hotel);
      this.totalNight = this.calculateTotalNight();

      var totalRoom = roomPrice * this.totalNight;
      this.totalRoomsPrice = totalRoom;
      this.totalPackagePrice = totalRoom + this.flightTotalPrice;
      return totalRoom + this.flightTotalPrice;
    },
    packageTotalRackPrice() {
      var roomPrice = this.calcRoomTotalRackPrice(
        this.bookingDetail.package.hotel
      );
      this.totalNight = this.calculateTotalNight();

      var totalRoom = roomPrice * this.totalNight;

      return totalRoom + this.flightTotalPrice;
    },
  },
  methods: {
    flightPriceDetail(flight) {
      var departurePrice = 0;
      var returnPrice = 0;
      var totalFlightPrice = 0;

      var departureProviderPrice = 0;
      var returnProviderPrice = 0;
      var totalFlightProviderPrice = 0;

      var departureAdultPrice =
        flight.departureFlight.adultQty * flight.departureFlight.totalAdultFare;
      var departureInfantPrice =
        flight.departureFlight.infantQty *
        flight.departureFlight.totalInfantFare;
      var departureChildPrice =
        flight.departureFlight.childQty * flight.departureFlight.totalChildFare;
      departurePrice =
        departureAdultPrice + departureInfantPrice + departureChildPrice;
      var returnAdultPrice =
        flight.returnFlight.adultQty * flight.returnFlight.totalAdultFare;
      var returnInfantPrice =
        flight.returnFlight.infantQty * flight.returnFlight.totalInfantFare;
      var returnChildPrice =
        flight.returnFlight.childQty * flight.returnFlight.totalChildFare;
      returnPrice = returnAdultPrice + returnInfantPrice + returnChildPrice;
      totalFlightPrice = departurePrice + returnPrice;

      this.departureFlightPrice = departurePrice;
      this.returnFlightPrice = returnPrice;
      this.totalFlightPrice = totalFlightPrice;

      var departureAdultProviderPrice =
        flight.departureFlight.adultQty *
        flight.departureFlight.totalAdultProvideFare;
      var departureInfantProviderPrice =
        flight.departureFlight.infantQty *
        flight.departureFlight.totalInfantProvideFare;
      var departureChildProviderPrice =
        flight.departureFlight.childQty *
        flight.departureFlight.totalChildProvideFare;
      departureProviderPrice =
        departureAdultProviderPrice +
        departureInfantProviderPrice +
        departureChildProviderPrice;
      var returnAdultProviderPrice =
        flight.returnFlight.adultQty *
        flight.returnFlight.totalAdultProvideFare;
      var returnInfantProviderPrice =
        flight.returnFlight.infantQty *
        flight.returnFlight.totalInfantProvideFare;
      var returnChildProviderPrice =
        flight.returnFlight.childQty *
        flight.returnFlight.totalChildProvideFare;
      returnProviderPrice =
        returnAdultProviderPrice +
        returnInfantProviderPrice +
        returnChildProviderPrice;
      totalFlightProviderPrice = departureProviderPrice + returnProviderPrice;

      this.departureFlightProviderPrice = departureProviderPrice;
      this.returnFlightProviderPrice = returnProviderPrice;
      this.totalFlightProviderPrice = totalFlightProviderPrice;
    },

    totalRoomPriceDetail() {
      this.bookingDetail.package.hotel.forEach((element) => {
        var res = this.roomPriceDetail(element);

        this.roomsPriceDetail.push(res);
      });
    },
    roomPriceDetail(room) {
      var noneFreeInfant = 0;
      var noneFreeChild = 0;
      var nOChild = room.numberOfChild;
      if (room.numberOfInfant > 1) {
        noneFreeInfant = room.numberOfInfant - 1;
      } else {
        noneFreeInfant = 0;
      }

      if (noneFreeInfant >= 1 && room.numberOfForFreeChild == 0) {
        room.numberOfForFreeChild = room.numberOfForFreeChild + 1;
        noneFreeInfant = noneFreeInfant - 1;
      }

      if (room.numberOfForFreeChild > 0 && nOChild == 0) {
        nOChild = room.numberOfForFreeChild;
      }
      if (room.numberOfForFreeChild > 1) {
        noneFreeChild = room.numberOfForFreeChild - 1;
      } else {
        noneFreeChild = 0;
      }
       var childPriceCount = noneFreeInfant + noneFreeChild;
      const pax = room.numberOfAdult + childPriceCount;
      const bedsCount = room.capacity;
      const extrabed = room.maximumExtraBed;
      const capacity = pax - bedsCount;
      const basePrice = room.basePrice;
      const discount = room.discount;

      var selectedExtraBed = 0;
      var childPrice = 0;
      var rackChildPrice = 0;

      var extraBedPrice = 0;
      var rackExtraBedPrice = 0;

      if (capacity > 0 && extrabed > 0) {
        selectedExtraBed = capacity;
 
        if (childPriceCount === selectedExtraBed) {
          childPrice = room.childPrice * childPriceCount;
          rackChildPrice = room.rackChildPrice * childPriceCount;
          extraBedPrice = 0;
        } else {
          if (childPriceCount > selectedExtraBed) {
            childPrice = room.childPrice * (childPriceCount - selectedExtraBed);
            rackChildPrice =
              room.rackChildPrice * (childPriceCount - selectedExtraBed);
          } else if (
            childPriceCount < selectedExtraBed &&
            childPriceCount > 0
          ) {
            childPrice = room.childPrice * childPriceCount;
            rackChildPrice = room.rackChildPrice * childPriceCount;

            extraBedPrice =
              room.extraBedPrice * (selectedExtraBed - childPriceCount);
            rackExtraBedPrice =
              room.rackExtraBedPrice * (selectedExtraBed - childPriceCount);
          } else if (
            childPriceCount < selectedExtraBed &&
            childPriceCount === 0 &&
            nOChild == 0
          ) {
            extraBedPrice = room.extraBedPrice * selectedExtraBed;
            rackExtraBedPrice = room.rackExtraBedPrice * selectedExtraBed;
          }
        }
      }
      var total = basePrice - discount + childPrice + extraBedPrice;
      var totalRackPrice = basePrice + rackChildPrice + rackExtraBedPrice;

      room.numberOfExtraBed = selectedExtraBed;
      var roomPrice = {
        totalRackPrice: totalRackPrice,
        totalRoomPrice: total,
        numberOfExtraBed: selectedExtraBed,
        extraBedPrice: extraBedPrice,
        roomExtraBedPrice: room.extraBedPrice,
        rackExtraBedPrice: room.rackExtraBedPrice,
        price: basePrice - discount + childPrice,
        rackPrice: basePrice,
        rackChildPrice: room.rackChildPrice,
        childPrice: room.childPrice,
        roomName: room.name,
        adult: room.numberOfAdult,
        child: room.numberOfChild,
        infant: room.numberOfInfant,
        childWithPrice: room.childWithPrice,
      };
      return roomPrice;
    },
    goBack() {
      this.$router.go(-1);
    },
    async getCredit() {
      var deposit = this.$store.getters.GetSelectedSourceDeposit;

      if (deposit < this.packageTotalPrice) {
        this.isDisableCreditChecked = true;
      }
      this.deposit = deposit;
    },
    async book() {
      var sourceId = localStorage.getItem("SourceIdInReport");
      this.isLoading = true;

      this.bookingDetail.totalPackagePrice = this.totalPackagePrice;
      this.bookingDetail.totalRoomsPrice = this.totalRoomsPrice;
      this.bookingDetail.flightTotalPrice = this.flightTotalPrice;

     
      if (this.isCredit=== true) {
        this.showCreditSpinner = true;

        var res = await this.$store.dispatch(
          "Book/CreditBook",
          this.bookingDetail
        );

        if (res) {
          if (res.result === 1) {
            this.reserveNo = res.data.reserveNumber;
          } else {
            this.reserveNo = res.result;
          }

          this.$router.push({
            path: "ticket",
            name: "FlightHotel Ticket",
            query: {
              id: this.reserveNo,
            },
          });
        }
        
      } else if (this.isCredit=== false){
        var res = await this.$store.dispatch(
          "Book/Reserve",
          this.bookingDetail
        );
        if (res) {
          if (res.result === 1) {
            this.$router.push({
              path: "payment",
              name: "FlightHotel Payment",
              query: {
                refrence: res.data.bankRefrenceId,
              },
            });
          } else {
            this.$router.push({
              path: "error",
              name: "FlightHotel Error",
              query: {
                id: res.result,
              },
            });
          }
        }
      }
    },
    calculateTotalNight() {
      
      var fromDate = dateUtil.ConvertToPersian(this.params.fromDate);
      var toDate = dateUtil.ConvertToPersian(this.params.toDate);
      if (
        fromDate !== "" &&
        fromDate !== null &&
        toDate !== "" &&
        toDate !== null
      ) {
        let fDate = this.params.fromDate;
        let tDate = this.params.toDate;
         var startDate = moment(fDate);
        var endDate = moment(tDate);
        let duration = moment.duration(endDate.diff(startDate));

      let diff = Math.round(duration.asDays()) ;
        // var diff = moment(tDate).diff(moment(fDate), "days");

        // var diff = moment(this.params.toDate).diff(moment(this.params.fromDate), "days");

        return diff;
      } else {
        return 0;
      }
    },
    calcFlightTotalPrice(flight) {
      var departurePrice = 0;
      var returnPrice = 0;
      var totalFlightPrice = 0;
      var departureAdultPrice =
        flight.departureFlight.adultQty * flight.departureFlight.totalAdultFare;
      var departureInfantPrice =
        flight.departureFlight.infantQty *
        flight.departureFlight.totalInfantFare;
      var departureChildPrice =
        flight.departureFlight.childQty * flight.departureFlight.totalChildFare;
      departurePrice =
        departureAdultPrice + departureInfantPrice + departureChildPrice;

      var returnAdultPrice =
        flight.returnFlight.adultQty * flight.returnFlight.totalAdultFare;
      var returnInfantPrice =
        flight.returnFlight.infantQty * flight.returnFlight.totalInfantFare;
      var returnChildPrice =
        flight.returnFlight.childQty * flight.returnFlight.totalChildFare;
      returnPrice = returnAdultPrice + returnInfantPrice + returnChildPrice;
      totalFlightPrice = departurePrice + returnPrice;
      return totalFlightPrice;
    },

    calcRoomTotalPrice: function (rooms) {
      return rooms.reduce((acc, val) => {
        return acc + parseInt(val.totalFarePrice);
      }, 0);
    },
    calcRoomTotalRackPrice: function (rooms) {
      return rooms.reduce((acc, val) => {
        return acc + parseInt(val.totalBasePrice);
      }, 0);
    },
    goToSearch() {
      this.$router
        .push({
          name: "hotelFlight",
          query: {
            origin: this.params.origin,
            destination: this.params.destination,
            originName: this.params.originName,
            destinationName: this.params.destinationName,
            fromDate: this.params.fromDate,
            toDate: this.params.toDate,
            rooms: this.params.rooms,
          },
        })
        .catch(() => {});
    },
    endTimeCountdown() {
      this.showTimerModal = true;
    },

    getSearchItems() {
      var rooms = JSON.parse(this.params.rooms);

      var pax = 0;
      var fromDate = dateUtil.ConvertToPersian(this.params.fromDate);
      var toDate = dateUtil.ConvertToPersian(this.params.toDate);
      var totalChild = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age >= 2) {
            totalChild = totalChild + 1;
          }
        });
      });

      var totalInfant = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age < 2) {
            totalInfant = totalInfant + 1;
          }
        });
      });

      var totalAdult = rooms.sum((t) => t.adults);
      this.searchItems = {
        origin: this.params.originName,
        destination: this.params.destinationName,
        fromDate: fromDate,
        toDate: toDate,
        pax: totalAdult + totalChild + totalInfant,
        rooms: rooms,
        roomsCount: rooms.length,
      };
    },
  },
  mounted() {
    require("magnific-popup");
    $(this.$el.querySelector("#role_link")).magnificPopup({
      type: "inline",
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });
  },
};
</script>
<style lang="scss" scoped>

.rwd-table {
  width: 100%;
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
  
}

.rwd-table-header {
  border-top: none;
background: #ffffff !important;
    color: #0c3a50;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
 background-color: #f7f7f7;
}
 .rwd-table tr th {
            text-align: right;
 }
  .rwd-table tr td {
            text-align: right;
 }


.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table {
  color: #333;
  border-radius: .4em;
  overflow: hidden;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    padding: 1em !important;
  }
}

.role {
  color: #0a6c9f !important;
  font-weight: bold;
  cursor: pointer !important;
}
.custom_form_title h3 strong {
  margin-top: -4px !important;
  margin-right: 3px !important;
  height: 35px !important;
  width: 35px !important;
  background-color: #bdc6cb !important;
}
.custom_form_title {
  margin-bottom: 0px !important;
  padding-right: 45px !important;
}

.custom_row {
  margin-top: 50px;
}
.styled-select {
  background-color: white !important;
  border: 1px solid #ced4da !important;
}

.radios {
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 640px) {
    flex-direction: column;
  }
}

.radio {
  input {
    position: absolute;
    pointer-events: none;
    visibility: hidden;
  }

  input:focus + label {
    background: #eeeeff;

    .checker {
      border-color: #6666ff;
    }
  }

  input:checked + label {
    .checker {
      box-shadow: inset 0 0 0 6px #6666ff;
      margin-left: 4px;
    }
  }

  label {
    display: flex;
    align-items: center;
    height: 28px;
    border-radius: 14px;
    margin: 10px;
    padding: 0 8px 0 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background: #eeeeff;

      .checker {
        box-shadow: inset 0 0 0 2px #6666ff;
      }
    }
  }

  .checker {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 8px;
    box-shadow: inset 0 0 0 2px #ccc;
    transition: box-shadow 0.3s ease;
    margin-left: 4px;
  }
}

.customer_request {
  margin-top: 50px;
  margin-bottom: 50px;
  text-align: initial;
  font-size: 14px;
  padding: 15px 5px 15px 5px;
  background: #fbfdff;
}

.edit_passengers {
  color: #0a6c9f !important;
  cursor: pointer;
}

.td_container {
  display: inline-grid;
  font-size: 15px;
}
.td_container #rack_price {
  text-decoration: line-through;
}

.addon-tb[data-v-40377d4f] {
    padding: 1em 0em;
    text-align: center;
}

.td_container #normal_price {
}
</style>